import { ChipPropsColorOverrides } from "@mui/material";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  PinpaperCrossIcon,
} from "@/components/common/icons";
import { ERROR_PRIMARY, GREY, PRIMARY } from "@/config/mui/colorPalette";

export enum FormStatus {
  INCOMPLETE = "Incomplete",
  SUBMITTED = "Submitted",
  EXPIRED = "Expired",
}

export const FormStatusColors: {
  [key in FormStatus]: keyof ChipPropsColorOverrides;
} = {
  [FormStatus.INCOMPLETE]: "lightGray",
  [FormStatus.SUBMITTED]: "green",
  [FormStatus.EXPIRED]: "red",
};

const Icons = {
  [FormStatus.INCOMPLETE]: <CrossCircleIcon color={GREY[50]} />,
  [FormStatus.SUBMITTED]: <CheckCircleIcon color={PRIMARY} />,
  [FormStatus.EXPIRED]: <PinpaperCrossIcon color={ERROR_PRIMARY} />,
};

export default function FormStatusIcon({ status }: { status: FormStatus }) {
  return <>{Icons[status]}</>;
}
